import { render, staticRenderFns } from "./PopupInvite.vue?vue&type=template&id=c458f54e"
import script from "./PopupInvite.vue?vue&type=script&lang=js"
export * from "./PopupInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports